import { freddieConnectionApi } from 'app/services/api';

import { createNamedActions } from 'utils/namedActionTypesProxy';

export const FREDDIE_CONNECTION_ACTION_TYPE = createNamedActions('marginCenter/freddieConnection', {
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',
  GET_CONNECTION: 'GET_CONNECTION',
  // SET_SAVING / SET_SAVE_ERROR / SAVE_CONNECTION are retained for the reducer's save slice: the
  // freddie-connection PUT is deprecated (LEN-67 — editing moved to the Integration Studio freddie-feed
  // card) so no action dispatches them anymore, but the slice + its reducer cases stay until the PUT is
  // fully retired in a follow-up.
  SET_SAVING: 'SET_SAVING',
  SET_SAVE_ERROR: 'SET_SAVE_ERROR',
  SAVE_CONNECTION: 'SAVE_CONNECTION',
});

export const getFreddieConnectionAction = () => async dispatch => {
  dispatch({ type: FREDDIE_CONNECTION_ACTION_TYPE.SET_LOADING, payload: true });

  try {
    const { data } = await freddieConnectionApi.getConnection();

    return dispatch({ type: FREDDIE_CONNECTION_ACTION_TYPE.GET_CONNECTION, payload: data });
  } catch {
    return dispatch({ type: FREDDIE_CONNECTION_ACTION_TYPE.SET_ERROR });
  }
};
